import React from "react";

export function MobileNumberPage({mobileNumber,setMobileNumber, generateOTP}) {

    function validateMobileNumber(inputValue){
        const regex = '^[0-9]*$';
        if(inputValue.match(regex) || inputValue.length < 11){
          setMobileNumber(inputValue);
        }
    }

  return (
    <div className="oauth-login-div d-flex justify-content-center">
      <form className="oauth-login-form" onSubmit={(ev) => generateOTP(ev)}>
        <p className="text-center oauth-login-description">
          Please enter your mobile number below to log in or sign up for Bankstown Sports or any of our associated venues
        </p>
        <p className="login-label">
          <strong>Mobile Number</strong>
        </p>
        <input
          required
          className="oauth-form-control login-field"
          minLength={10}
          maxLength={10}
          pattern="[0][4][0-9]{8}"
          onChange={(ev) => validateMobileNumber(ev.target.value)}
        />
        <button className="form-btn btn btn-primary" type="submit">
          NEXT
        </button>
      </form>
    </div>
  );
}
